(function initHeader() {
  // app.js가 window.__lockGlobalScroll 를 모듈 평가 이후에 설정하므로(ESM import 호이스팅),
  // 캐싱하지 않고 호출 시점에 조회해 타이밍에 관계없이 동작하도록 한다.
  const lockGlobalScroll = (key) => (window.__lockGlobalScroll ?? (() => {}))(key);
  const unlockGlobalScroll = (key) => (window.__unlockGlobalScroll ?? (() => {}))(key);
  const header = document.getElementById("main-header");

  if (!header) return;

  const drawer = document.getElementById("main-drawer");
  const backdrop = document.getElementById("backdrop");
  const modalCloseBtn = document.querySelector(".no-modal__close");
  const drawerOpenBtn = header.querySelector(".no-header__toggle");
  const drawerCenter =
    drawer?.querySelector(".no-drawer__scroll-target") ??
    drawer?.querySelector(".no-drawer__center") ??
    null;

  const setDrawerLangOpen = (wrap, open) => {
    if (!(wrap instanceof HTMLElement)) return;
    wrap.classList.toggle("is-open", open);
    const menu = wrap.querySelector(".no-drawer__lang-menu");
    const trigger = wrap.querySelector(".no-drawer__lang-btn");
    if (!menu || !trigger) return;
    if (open) {
      menu.removeAttribute("hidden");
      trigger.setAttribute("aria-expanded", "true");
      return;
    }
    menu.setAttribute("hidden", "");
    trigger.setAttribute("aria-expanded", "false");
  };

  const collapseDrawerAccordionItem = (itemEl) => {
    if (!(itemEl instanceof HTMLElement)) return;
    const panel = itemEl.querySelector(".no-drawer__panel");
    const btn = itemEl.querySelector(".no-drawer__head-toggle");
    if (!panel || !btn) return;
    itemEl.classList.remove("is-open");
    btn.setAttribute("aria-expanded", "false");
    panel.setAttribute("aria-hidden", "true");
  };

  const expandDrawerAccordionItem = (itemEl) => {
    if (!(itemEl instanceof HTMLElement)) return;
    const panel = itemEl.querySelector(".no-drawer__panel");
    const btn = itemEl.querySelector(".no-drawer__head-toggle");
    if (!panel || !btn) return;
    itemEl.classList.add("is-open");
    btn.setAttribute("aria-expanded", "true");
    panel.setAttribute("aria-hidden", "false");
  };

  const resetDrawerMenuState = () => {
    if (!drawer) return;
    drawer
      .querySelectorAll(".no-drawer__item.is-open")
      .forEach((node) => collapseDrawerAccordionItem(node));
    drawer
      .querySelectorAll("[data-drawer-lang]")
      .forEach((wrap) => setDrawerLangOpen(wrap, false));
  };
  const branchSwitcher = header.querySelector("[data-branch-switcher]");
  const branchBtn = branchSwitcher?.querySelector(".no-header__branch-btn");
  const desktopNav = header.querySelector(".no-header__nav");
  const desktopNavMedia = window.matchMedia("(min-width: 1025px)");
  const desktopSubmenus = Array.from(
    header.querySelectorAll(".no-header__submenu"),
  );
  desktopNav?.setAttribute("data-expanded", "false");

  let drawerMenuTextTween = null;
  let backdropTl = null;
  let submenuResizeObserver = null;
  let headerNavigationInFlight = false;
  let desktopSubmenuCloseTimer = 0;
  let desktopSubmenuMasterTl = null;
  let headerChromeTween = null;
  let headerBaseHeight = 0;
  let closeAllGnbSubmenus = () => {};

  const syncDesktopSubmenuHeights = () => {
    header.style.setProperty("--header-nav-extra-height", "0px");
  };

  const clearDesktopSubmenuCloseTimer = () => {
    if (!desktopSubmenuCloseTimer) return;
    window.clearTimeout(desktopSubmenuCloseTimer);
    desktopSubmenuCloseTimer = 0;
  };

  const syncHeaderBaseHeight = () => {
    const headerInner = header.querySelector(".no-header__inner");
    headerBaseHeight =
      headerInner?.getBoundingClientRect().height ||
      header.getBoundingClientRect().height ||
      headerBaseHeight ||
      0;
  };

  const getHeaderBaseHeight = () => headerBaseHeight;

  const getHeaderScrollThreshold = () => {
    const measured = getHeaderBaseHeight();
    if (measured > 0) return measured;

    const cssVar = getComputedStyle(document.documentElement)
      .getPropertyValue("--header-height")
      .trim();
    const parsed = parseFloat(cssVar);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 75;
  };

  const getScrollY = () => {
    const lenisScroll = window.__lenis?.scroll;
    if (typeof lenisScroll === "number") {
      return Math.max(0, lenisScroll);
    }
    return Math.max(
      0,
      window.scrollY ||
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        0,
    );
  };

  const isDesktopNavExpanded = () =>
    Boolean(
      desktopNav &&
      desktopNavMedia.matches &&
        desktopNav.getAttribute("data-expanded") === "true",
    );

  /** 맨 위에서는 배경 없음; 헤더 높이를 넘기면 솔리드 스타일(`is-scrolled`) */
  const shouldUseSolidHeader = () => {
    const scrollY = getScrollY();
    if (scrollY <= 1) return false;
    return scrollY > getHeaderScrollThreshold();
  };

  const getHeaderChromeTarget = (expanded = isDesktopNavExpanded()) => {
    const baseHeight = getHeaderBaseHeight();

    if (expanded || shouldUseSolidHeader()) {
      return {
        height: baseHeight,
        surfaceOpacity: 0,
        surfaceBlur: "0px",
        shadowOpacity: 0,
      };
    }

    return {
      height: baseHeight,
      surfaceOpacity: 0,
      surfaceBlur: "0px",
      shadowOpacity: 0,
    };
  };

  const applyHeaderChrome = ({
    expanded,
    immediate = false,
    delay = 0,
    duration,
    ease,
  } = {}) => {
    const target = getHeaderChromeTarget(expanded);

    headerChromeTween?.kill();

    if (immediate) {
      gsap.set(header, {
        height: target.height,
        "--header-surface-opacity": target.surfaceOpacity,
        "--header-surface-blur": target.surfaceBlur,
        "--header-shadow-opacity": target.shadowOpacity,
      });
      return null;
    }

    return new Promise((resolve) => {
      headerChromeTween = gsap.to(header, {
        height: target.height,
        "--header-surface-opacity": target.surfaceOpacity,
        "--header-surface-blur": target.surfaceBlur,
        "--header-shadow-opacity": target.shadowOpacity,
        delay,
        duration: duration ?? (expanded ? 0.38 : 0.28),
        ease: ease ?? (expanded ? "power3.out" : "power2.out"),
        overwrite: true,
        onComplete: () => {
          headerChromeTween = null;
          resolve();
        },
      });
    });
  };

  const buildDesktopSubmenuTimeline = () => {
    if (!desktopSubmenus.length) {
      desktopSubmenuMasterTl = null;
      return;
    }

    const submenuItems = desktopSubmenus.flatMap((submenu) =>
      Array.from(submenu.querySelectorAll(".no-header__lnb-item")),
    );

    if (!submenuItems.length) {
      desktopSubmenuMasterTl = null;
      return;
    }

    desktopSubmenuMasterTl?.kill();
    desktopSubmenuMasterTl = gsap.timeline({ paused: true });
    desktopSubmenuMasterTl.to(submenuItems, {
      opacity: 1,
      y: 0,
      duration: 0.32,
      ease: "power3.out",
      stagger: {
        each: 0.045,
        from: "start",
      },
    });
  };

  const playDesktopSubmenuReveal = () => {
    if (!desktopSubmenuMasterTl) return;
    clearDesktopSubmenuCloseTimer();
    desktopNav?.classList.add("is-submenu-active");
    desktopSubmenuMasterTl.play();
  };

  const reverseDesktopSubmenuReveal = () => {
    if (!desktopSubmenuMasterTl || !desktopNav) {
      desktopNav?.classList.remove("is-submenu-active");
      return Promise.resolve();
    }

    clearDesktopSubmenuCloseTimer();
    return new Promise((resolve) => {
      let settled = false;
      const previousReverseComplete =
        desktopSubmenuMasterTl.eventCallback("onReverseComplete");

      const finish = () => {
        if (settled) return;
        settled = true;
        window.clearTimeout(timerId);
        desktopNav.classList.remove("is-submenu-active");
        desktopSubmenuCloseTimer = 0;
        desktopSubmenuMasterTl.eventCallback(
          "onReverseComplete",
          previousReverseComplete ?? null,
        );
        if (typeof previousReverseComplete === "function") {
          previousReverseComplete();
        }
        resolve();
      };

      const timerId = window.setTimeout(finish, 360);

      desktopSubmenuMasterTl.eventCallback("onReverseComplete", finish);

      if (desktopSubmenuMasterTl.progress() <= 0) {
        finish();
        return;
      }

      desktopSubmenuMasterTl.reverse();
    });
  };

  const setDesktopNavExpanded = (expanded) => {
    if (!desktopNav || !desktopNavMedia.matches) return;
    syncDesktopSubmenuHeights();
    desktopNav.setAttribute("data-expanded", expanded ? "true" : "false");
    if (expanded) {
      header.classList.add("is-nav-expanded");
      playDesktopSubmenuReveal();
      return applyHeaderChrome({ expanded: true });
    }
    const submenuReversePromise = reverseDesktopSubmenuReveal();
    closeBackdrop();
    const collapsePromise = submenuReversePromise.then(() =>
      applyHeaderChrome({
        expanded: false,
        duration: 0.3,
        ease: "power2.out",
      }),
    );
    collapsePromise.finally(() => {
      header.classList.remove("is-nav-expanded");
    });
    return collapsePromise;
  };

  if (desktopNav) {
    const handleDesktopNavClose = () => {
      setDesktopNavExpanded(false);
    };
    const handleDesktopNavOpen = () => setDesktopNavExpanded(true);

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeAllGnbSubmenus();
      }
    });

    const gnbItemsWithSubmenu = Array.from(
      header.querySelectorAll(".no-header__gnb-item[data-has-submenu]"),
    );

    closeAllGnbSubmenus = () => {
      gnbItemsWithSubmenu.forEach((item) => {
        item.classList.remove("is-open");
        const link = item.querySelector(".no-header__gnb-link");
        if (link) link.setAttribute("aria-expanded", "false");
      });
    };

    gnbItemsWithSubmenu.forEach((item) => {
      const link = item.querySelector(".no-header__gnb-link");
      const submenu = item.querySelector(".no-header__submenu");
      if (!link) return;

      link.setAttribute("aria-expanded", "false");

      item.addEventListener("mouseenter", () => {
        if (!desktopNavMedia.matches) return;
        item.classList.add("is-open");
        link.setAttribute("aria-expanded", "true");
        if (submenu) {
          const lnbItems = Array.from(
            submenu.querySelectorAll(".no-header__lnb-item"),
          );
          gsap.fromTo(
            lnbItems,
            { opacity: 0, y: 6 },
            {
              opacity: 1,
              y: 0,
              duration: 0.28,
              ease: "power3.out",
              stagger: { each: 0.04 },
            },
          );
        }
      });

      item.addEventListener("mouseleave", () => {
        if (!desktopNavMedia.matches) return;
        item.classList.remove("is-open");
        link.setAttribute("aria-expanded", "false");
      });
    });

    syncHeaderBaseHeight();
    syncDesktopSubmenuHeights();
    buildDesktopSubmenuTimeline();

    if ("ResizeObserver" in window) {
      submenuResizeObserver = new ResizeObserver(() => {
        syncDesktopSubmenuHeights();
        buildDesktopSubmenuTimeline();
      });

      desktopNav.querySelectorAll(".no-header__submenu").forEach((submenu) => {
        submenuResizeObserver.observe(submenu);
      });
    }

    window.addEventListener("resize", () => {
      syncHeaderBaseHeight();
      syncDesktopSubmenuHeights();
      buildDesktopSubmenuTimeline();
      applyHeaderChrome({ immediate: true });
    });
    window.addEventListener(
      "load",
      () => {
        syncHeaderBaseHeight();
        syncDesktopSubmenuHeights();
        buildDesktopSubmenuTimeline();
        applyHeaderChrome({ immediate: true });
      },
      { once: true },
    );

    desktopNavMedia.addEventListener("change", (event) => {
      if (!event.matches) {
        clearDesktopSubmenuCloseTimer();
        desktopNav.classList.remove("is-submenu-active");
        desktopNav.setAttribute("data-expanded", "false");
        header.classList.remove("is-nav-expanded");
        desktopSubmenuMasterTl?.pause(0);
        applyHeaderChrome({ immediate: true });
        return;
      }

      syncDesktopSubmenuHeights();
      syncHeaderBaseHeight();
      buildDesktopSubmenuTimeline();
      applyHeaderChrome({ immediate: true });
    });
  }

  if (backdrop) {
    backdropTl = gsap.timeline({ paused: true });
    backdropTl.to(backdrop, {
      opacity: 1,
      ease: "power2.out",
      duration: 0.22,
    });
    backdropTl.eventCallback("onReverseComplete", () => {
      backdrop.classList.remove("is-active");
      backdrop.setAttribute("aria-hidden", "true");
    });
  }

  const openBackdrop = () => {
    if (!backdrop || !backdropTl) return;
    backdrop.setAttribute("aria-hidden", "false");
    backdrop.classList.add("is-active");
    backdropTl.play();
  };

  const waitForHeaderTransition = (propertyName, timeout = 320) =>
    new Promise((resolve) => {
      let settled = false;

      const finish = () => {
        if (settled) return;
        settled = true;
        header.removeEventListener("transitionend", handleTransitionEnd);
        window.clearTimeout(timerId);
        resolve();
      };

      const handleTransitionEnd = (event) => {
        if (event.target !== header) return;
        if (propertyName && event.propertyName !== propertyName) return;
        finish();
      };

      const timerId = window.setTimeout(finish, timeout);
      header.addEventListener("transitionend", handleTransitionEnd);
    });

  const closeBackdrop = (force = false) => {
    if (!backdrop || !backdropTl) return;
    if (force) {
      backdropTl.reverse();
      return;
    }
    const drawerOpen = drawer && drawer.getAttribute("data-state") === "open";
    const navExpanded =
      desktopNav &&
      desktopNavMedia.matches &&
      desktopNav.getAttribute("data-expanded") === "true";
    if (!drawerOpen && !navExpanded) {
      backdropTl.reverse();
    }
  };

  const openDrawer = () => {
    if (!drawer) return;

    resetDrawerMenuState();

    drawer.setAttribute("data-state", "open");
    drawer.setAttribute("aria-hidden", "false");
    drawer.style.opacity = "";
    drawer.style.visibility = "";
    drawer.classList.remove("is-closing");
    drawer.classList.add("is-active", "is-expanded");
    header.classList.add("is-drawer-open");
    if (drawerCenter) {
      drawerCenter.scrollTop = 0;
    }
    if (drawerOpenBtn) {
      drawerOpenBtn.setAttribute("aria-expanded", "true");
    }
    if (modalCloseBtn) {
      modalCloseBtn.classList.add("is-visible");
    }
    closeBranchMenu();
    const drawerTextTargets = drawer.querySelectorAll(
      ".no-drawer__item, .no-drawer__cta-wrap",
    );

    drawerMenuTextTween?.kill();
    gsap.set(drawerTextTargets, {
      opacity: 0,
      y: 18,
    });
    drawerMenuTextTween = gsap.to(drawerTextTargets, {
      opacity: 1,
      y: 0,
      duration: 0.48,
      ease: "power3.out",
      stagger: {
        each: 0.08,
        from: "start",
      },
      delay: 0.06,
      overwrite: true,
    });
  };

  const closeDrawer = ({ wait = false } = {}) => {
    if (!drawer) return;
    const waitPromise = wait
      ? new Promise((resolve) => window.setTimeout(resolve, 380))
      : null;

    drawer.setAttribute("data-state", "closed");
    drawer.setAttribute("aria-hidden", "true");
    drawer.classList.remove("is-expanded");
    drawer.classList.add("is-closing");
    header.classList.remove("is-drawer-open");
    if (drawerOpenBtn) {
      drawerOpenBtn.setAttribute("aria-expanded", "false");
    }
    if (modalCloseBtn) {
      modalCloseBtn.classList.remove("is-visible");
    }
    drawerMenuTextTween?.kill();

    window.setTimeout(() => {
      if (drawer.getAttribute("data-state") === "open") {
        return;
      }
      drawer.style.opacity = "";
      drawer.style.visibility = "";
      drawer.classList.remove("is-active", "is-closing");
      resetDrawerMenuState();
    }, 360);

    return waitPromise;
  };

  const closeBranchMenu = () => {
    branchSwitcher?.classList.remove("is-open");
    branchBtn?.setAttribute("aria-expanded", "false");
    header.classList.remove("is-branch-open");
  };

  if (branchSwitcher && branchBtn) {
    branchBtn.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (drawer && drawer.getAttribute("data-state") === "open") {
        closeDrawer();
      }
      const willOpen = !branchSwitcher.classList.contains("is-open");
      branchSwitcher.classList.toggle("is-open", willOpen);
      header.classList.toggle("is-branch-open", willOpen);
      branchBtn.setAttribute("aria-expanded", willOpen ? "true" : "false");
    });
  }

  document.addEventListener("click", (event) => {
    if (branchSwitcher && !branchSwitcher.contains(event.target)) {
      closeBranchMenu();
    }

    if (!header.contains(event.target)) {
      closeAllGnbSubmenus();
    }

    const openDrawerLang = drawer?.querySelector("[data-drawer-lang].is-open");
    const target =
      event.target instanceof Node ? event.target : null;
    if (
      openDrawerLang &&
      target instanceof Node &&
      !openDrawerLang.contains(target)
    ) {
      setDrawerLangOpen(openDrawerLang, false);
    }
  });

  const closeHeaderUiBeforeNavigation = async () => {
    const tasks = [];
    const desktopNavExpanded =
      desktopNav &&
      desktopNavMedia.matches &&
      desktopNav.getAttribute("data-expanded") === "true";
    const drawerOpen = drawer && drawer.getAttribute("data-state") === "open";
    const headerHidden = header.classList.contains("is-hidden");

    if (desktopNavExpanded) {
      const submenuDone = reverseDesktopSubmenuReveal();
      closeBackdrop();
      desktopNav.setAttribute("data-expanded", "false");
      submenuDone
        .then(() =>
          applyHeaderChrome({
            expanded: false,
            duration: 0.3,
            ease: "power2.out",
          }),
        )
        .finally(() => header.classList.remove("is-nav-expanded"));
      tasks.push(submenuDone);
    }

    if (drawerOpen) {
      const drawerPromise = closeDrawer({ wait: true });
      if (drawerPromise) {
        tasks.push(drawerPromise);
      }
    }

    if (headerHidden) {
      header.classList.remove("is-hidden");
      tasks.push(waitForHeaderTransition("transform"));
    }

    if (!tasks.length) {
      return false;
    }

    const timeout = new Promise((resolve) => window.setTimeout(resolve, 500));
    await Promise.race([Promise.all(tasks), timeout]);
    return true;
  };

  const isInterceptableHeaderNavigation = (link, event) => {
    if (!(link instanceof HTMLAnchorElement) || !link.href) return false;
    if (event.defaultPrevented) return false;
    if (event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return false;
    }
    if (link.hasAttribute("download")) return false;
    if ((link.getAttribute("target") || "").toLowerCase() === "_blank") {
      return false;
    }

    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin) return false;
    if (url.pathname === window.location.pathname && url.hash) return false;

    return true;
  };

  document.addEventListener("click", async (event) => {
    const link = event.target.closest("a");

    if (!isInterceptableHeaderNavigation(link, event)) {
      return;
    }

    const hasEphemeralHeaderUi =
      (desktopNav &&
        desktopNavMedia.matches &&
        desktopNav.getAttribute("data-expanded") === "true") ||
      (drawer && drawer.getAttribute("data-state") === "open") ||
      header.classList.contains("is-hidden");

    if (!hasEphemeralHeaderUi || headerNavigationInFlight) {
      return;
    }

    event.preventDefault();
    headerNavigationInFlight = true;

    try {
      await closeHeaderUiBeforeNavigation();
      window.location.assign(link.href);
    } finally {
      window.setTimeout(() => {
        headerNavigationInFlight = false;
      }, 400);
    }
  });

  if (drawer) {
    drawer.addEventListener("click", (e) => {
      const langBtn = e.target.closest(".no-drawer__lang-btn");
      if (langBtn && drawer.contains(langBtn)) {
        e.preventDefault();
        e.stopPropagation();
        const wrap = langBtn.closest("[data-drawer-lang]");
        if (!(wrap instanceof HTMLElement)) return;
        const wasOpen = wrap.classList.contains("is-open");
        drawer.querySelectorAll("[data-drawer-lang]").forEach((node) =>
          setDrawerLangOpen(node, false),
        );
        if (!wasOpen) setDrawerLangOpen(wrap, true);
        return;
      }

      const headToggle = e.target.closest(".no-drawer__head-toggle");
      if (headToggle && drawer.contains(headToggle)) {
        e.preventDefault();
        e.stopPropagation();
        const item = headToggle.closest(".no-drawer__item");
        if (!(item instanceof HTMLElement)) return;
        const opensNext = !item.classList.contains("is-open");
        if (opensNext) {
          drawer
            .querySelectorAll(".no-drawer__item.is-open")
            .forEach((openItem) => {
              if (openItem !== item) collapseDrawerAccordionItem(openItem);
            });
          expandDrawerAccordionItem(item);
        } else {
          collapseDrawerAccordionItem(item);
        }
        drawer
          .querySelectorAll("[data-drawer-lang]")
          .forEach((wrap) => setDrawerLangOpen(wrap, false));
      }
    });

    if (drawerOpenBtn) {
      drawerOpenBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (drawer && drawer.getAttribute("data-state") === "open") {
          closeDrawer();
          return;
        }
        openDrawer();
      });
    }
  }

  if (backdrop) {
    backdrop.addEventListener("click", (e) => {
      if (e.target === backdrop) {
        if (drawer && drawer.getAttribute("data-state") === "open") {
          closeDrawer();
        }
      }
    });
  }

  if (modalCloseBtn) {
    modalCloseBtn.addEventListener("click", () => {
      if (drawer && drawer.getAttribute("data-state") === "open") {
        closeDrawer();
      }
    });
  }

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;

    const activeLang = drawer?.querySelector("[data-drawer-lang].is-open");
    if (activeLang) {
      setDrawerLangOpen(activeLang, false);
      e.preventDefault();
      return;
    }

    closeBranchMenu();
    if (drawer && drawer.getAttribute("data-state") === "open") {
      closeDrawer();
    }
  });

  const heroSection = document.querySelector(".no-main--hero");
  if (heroSection) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            header.classList.add("visual");
          } else {
            header.classList.remove("visual");
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px",
      },
    );

    observer.observe(heroSection);
  }

  const syncHeaderScrollState = ({ immediate = false } = {}) => {
    const shouldBeScrolled = shouldUseSolidHeader();
    const wasScrolled = header.classList.contains("is-scrolled");

    header.classList.toggle("is-scrolled", shouldBeScrolled);

    if (shouldBeScrolled === wasScrolled || isDesktopNavExpanded()) {
      return;
    }

    applyHeaderChrome({ immediate });
  };

  const handleHeaderScroll = () => {
    syncHeaderScrollState();
  };

  const bindLenisHeaderScroll = () => {
    const lenis = window.__lenis;
    if (!lenis || lenis.__headerScrollBound) return;
    lenis.__headerScrollBound = true;
    lenis.on("scroll", handleHeaderScroll);
  };

  const runHeaderScrollSync = () => {
    syncHeaderBaseHeight();
    syncHeaderScrollState({ immediate: true });
  };

  window.__syncHeaderScrollState = runHeaderScrollSync;

  runHeaderScrollSync();
  window.addEventListener("scroll", handleHeaderScroll, { passive: true });
  bindLenisHeaderScroll();
  document.addEventListener("DOMContentLoaded", () => {
    bindLenisHeaderScroll();
    runHeaderScrollSync();
  });
  window.addEventListener("load", runHeaderScrollSync, { once: true });
  window.addEventListener("pageshow", runHeaderScrollSync);
  window.addEventListener("resize", runHeaderScrollSync);
  requestAnimationFrame(() => {
    requestAnimationFrame(runHeaderScrollSync);
  });

  const restoreHeaderAfterSnapshot = () => {
    header.style.transition = "";
    header.style.height = "";
    header.classList.remove("is-transition-freeze");
  };

  const freezeHeaderForSnapshot = () => {
    backdropTl?.kill();
    headerChromeTween?.kill();

    header.style.transition = "none";
    header.style.height = `${header.offsetHeight}px`;
    header.classList.add("is-transition-freeze");

    void header.offsetHeight;
  };

  const normalizeEphemeralUi = () => {
    closeAllGnbSubmenus();
    if (desktopNav) {
      clearDesktopSubmenuCloseTimer();
      desktopNav.classList.remove("is-submenu-active");
      desktopSubmenuMasterTl?.pause(0);
      desktopNav.setAttribute("data-expanded", "false");
    }
    header.classList.remove("is-nav-expanded", "is-hidden");

    if (backdrop) {
      backdropTl?.pause(0);
      backdrop.classList.remove("is-active");
      backdrop.setAttribute("aria-hidden", "true");
    }

    if (drawer) {
      resetDrawerMenuState();
      drawer.classList.remove("is-active", "is-expanded");
      drawer.setAttribute("data-state", "closed");
      drawer.setAttribute("aria-hidden", "true");
      drawerOpenBtn?.setAttribute("aria-expanded", "false");
    }
    header.classList.remove("is-drawer-open");

    ["drawer", "apply-result-modal"].forEach((key) => {
      unlockGlobalScroll(key);
    });
    modalCloseBtn?.classList.remove("is-visible");
    applyHeaderChrome({ immediate: true });
  };

  const handlePageSwap = () => {
    freezeHeaderForSnapshot();
  };

  const handlePageReveal = () => {
    normalizeEphemeralUi();
    restoreHeaderAfterSnapshot();
    runHeaderScrollSync();
    applyHeaderChrome({ immediate: true });
  };

  window.addEventListener("pageswap", handlePageSwap);
  window.addEventListener("pagereveal", handlePageReveal);
  window.addEventListener("pageshow", handlePageReveal);
})();
